export const withPayloadType =
  <T>() =>
  (t: T) => ({ payload: t })
